import { useEffect, useState } from "react";

const KEY = "vorra_compare";
const EVT = "vorra-compare";

export const readTray = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]").slice(0, 2); } catch { return []; } };
const write = (items) => { localStorage.setItem(KEY, JSON.stringify(items.slice(0, 2))); window.dispatchEvent(new Event(EVT)); };
export const snapshot = (l) => ({ id: l.id, make: l.make, model: l.model, year: l.year, price: l.price, photo: l.photos?.[0] || null });

export function addToTray(car, slot) {
  const items = readTray().filter((c) => c.id !== car.id);
  if (slot === 0 || slot === 1) { items[slot] = car; write(items.filter(Boolean)); return; }
  if (items.length >= 2) items[1] = car; else items.push(car);
  write(items);
}
export const removeFromTray = (id) => write(readTray().filter((c) => c.id !== id));
export const clearTray = () => write([]);
export const setDragging = (on) => window.dispatchEvent(new CustomEvent("vorra-drag", { detail: on }));

export function useCompareTray() {
  const [items, setItems] = useState(readTray);
  useEffect(() => {
    const sync = () => setItems(readTray());
    window.addEventListener(EVT, sync);
    window.addEventListener("storage", sync);
    return () => { window.removeEventListener(EVT, sync); window.removeEventListener("storage", sync); };
  }, []);
  return items;
}
